import { Pencil, Trash2 } from "lucide-react";
import { vendorCode, vendorName } from "../../../../../utils/vendorDisplay";

const PRICE_HEADERS = [
  "Service",
  "Language Pair",
  "Specialization",
  "Currency",
  "Unit",
  "Price/Unit",
  "Actions",
];

// showVendor prepends the vendor columns, which the master price list needs and
// a single vendor's own tab does not.
const PriceListTable = ({
  data,
  onEdit,
  onDelete,
  readOnly = false,
  showVendor = false,
  emptyMessage = "No price list found.",
}) => {
  const headers = showVendor
    ? ["Vendor Code", "Vendor Name", ...PRICE_HEADERS]
    : PRICE_HEADERS;

  return (
    <div className="w-full bg-white shadow rounded-lg overflow-hidden">
      <div className="max-h-[600px] overflow-y-auto overflow-x-auto">
        <table
          className={`w-full table-auto border-collapse ${
            showVendor ? "min-w-[1100px]" : "min-w-[900px]"
          }`}
        >
          <thead className="sticky top-0 z-10">
            <tr className="bg-white border-b text-[10px] tracking-widest text-gray-500 uppercase">
              {headers.map((h) => (
                <th
                  key={h}
                  className="px-3 py-2 text-center font-semibold whitespace-nowrap"
                >
                  {h}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.length === 0 ? (
              <tr>
                <td
                  colSpan={headers.length}
                  className="py-10 text-center text-gray-400 text-xs"
                >
                  {emptyMessage}
                </td>
              </tr>
            ) : (
              data.map((item, index) => {
                const rowBg = index % 2 === 0 ? "bg-gray-50" : "bg-white";
                const langPair =
                  item.languagePair?.sourceLanguage && item.languagePair?.targetLanguage
                    ? `${item.languagePair.sourceLanguage.code} → ${item.languagePair.targetLanguage.code}`
                    : "—";
                return (
                  <tr
                    key={item.id}
                    className={`${rowBg} hover:bg-brand-50 transition-colors`}
                  >
                    {showVendor && (
                      <>
                        <td className="px-3 py-2 text-xs whitespace-nowrap text-center font-medium text-gray-900">
                          {item.vendor?.id ? vendorCode(item.vendor.id) : "—"}
                        </td>
                        <td className="px-3 py-2 text-xs text-center text-gray-700">
                          {vendorName(item.vendor)}
                        </td>
                      </>
                    )}
                    <td className="px-3 py-2 text-xs whitespace-nowrap text-center text-gray-900">
                      {item.service?.name || "—"}
                    </td>
                    <td className="px-3 py-2 text-xs whitespace-nowrap text-center text-gray-700">
                      {langPair}
                    </td>
                    <td className="px-3 py-2 text-xs whitespace-nowrap text-center text-gray-700">
                      {item.specialization?.name || "—"}
                    </td>
                    <td className="px-3 py-2 text-xs whitespace-nowrap text-center text-gray-700">
                      {item.currency?.currency?.code || "—"}
                    </td>
                    <td className="px-3 py-2 text-xs whitespace-nowrap text-center text-gray-700">
                      {item.unit || "—"}
                    </td>
                    <td className="px-3 py-2 text-xs whitespace-nowrap text-center text-gray-900 font-medium">
                      {item.price_per_unit ?? "—"}
                    </td>
                    <td className="px-3 py-2 text-center whitespace-nowrap">
                      {readOnly ? (
                        <span className="text-[10px] text-gray-400">—</span>
                      ) : (
                        <div className="flex justify-center gap-3">
                          <Pencil
                            className="w-4 h-4 text-brand-400 hover:text-brand-600 cursor-pointer transition-colors"
                            title="Edit"
                            onClick={() => onEdit?.(item)}
                          />
                          {onDelete && (
                            <Trash2
                              className="w-4 h-4 text-danger-400 hover:text-danger-600 cursor-pointer transition-colors"
                              title="Delete"
                              onClick={() => onDelete(item)}
                            />
                          )}
                        </div>
                      )}
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PriceListTable;
